export const authEnum = {
  authToken: "authToken",
};

export const API = {
  auth: "/dummyData/authToken.json",
};
